import styleInject from '../../util/injectCss.js';

var css_248z = ".SidebarFooter__JWZLO_v2-52-0 {\n  position: relative;\n  padding: 1rem;\n  background-color: white;\n}\n.SidebarFooter___withShadow__VqbbE_v2-52-0 {\n  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.101961); /* stylelint-disable-line number-max-precision */\n}";
var styles = {"SidebarFooter":"SidebarFooter__JWZLO_v2-52-0","SidebarFooter___withShadow":"SidebarFooter___withShadow__VqbbE_v2-52-0"};
styleInject(css_248z);

export { styles as default };
